<template>
  <div v-if="display" class="image-holder">
    <div class="image-title">
      <h5>{{ images[selectedImageIndex]?.name }}</h5>
    </div>
    <div class="cancel-btn" @click="display = false">
      <i class="bi bi-x-lg"></i>
    </div>
    <div class="navigate-button-holder">
      <div
        class="navigate-buttons left"
        @click="selectedImageIndex > 0 ? selectedImageIndex-- : null"
      >
        <i class="bi bi-chevron-left"></i>
      </div>
      <div
        class="navigate-buttons right"
        @click="
          selectedImageIndex < images.length - 1 ? selectedImageIndex++ : null
        "
      >
        <i class="bi bi-chevron-right"></i>
      </div>
    </div>
    <div class="image" v-if="images.length > 0">
      <img :src="images[selectedImageIndex]?.path" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      display: false,
      images: [],
      selectedImageIndex: 0,
      imageHeight: 0,
      screenHalf: 0
    };
  },
  created() {
    this.emitter.on('setImagesForImageViewer', this.setImages);
    this.emitter.on('showImageViewer', this.showImageViewer);
  },
  methods: {
    getBrowserDimensions() {
      return {
        width:
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        height:
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight
      };
    },
    setImages(imageInfo) {
      this.images = imageInfo.images;
      this.selectedImageIndex = imageInfo.selectedImageIndex;
    },
    showImageViewer() {
      this.display = true;

      // Set Dimensions
      let browserDimension = this.getBrowserDimensions();
      this.imageHeight = browserDimension.height - 20 + 'px';
      this.screenHalf = browserDimension.height / 2 + 'px';
    }
  }
};
</script>

<style scoped>
.image-holder {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  overflow: auto;
}
.image-holder .image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.image-holder .image img {
  max-width: 80%;
  max-height: v-bind('imageHeight');
}
.cancel-btn {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  line-height: 31px;
  text-align: center;
  cursor: pointer;
  position: fixed;
  top: 20px;
  right: 30px;
}
.navigate-button-holder .navigate-buttons {
  position: fixed;
  background: rgba(255, 255, 255, 0.8);
  top: v-bind('screenHalf');
  width: 35px;
  height: 35px;
  line-height: 37px;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  font-size: 20px;
}
.navigate-button-holder .left {
  left: 5px;
  margin-left: 5px;
}
.navigate-button-holder .right {
  right: 5px;
  margin-right: 5px;
}

.image-title {
  position: absolute;
  top: 20px;
  left: 30px;
}
.image-title h5 {
  color: #fff;
}
</style>
